import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetUserVideoIntegrations as GetUserVideoIntegrationsQuery,
    UserVideoIntegrationsFragment,
} from 'nutshell-graphql-types';

import GET_USER_VIDEO_INTEGRATIONS from '../queries/get-user-video-integrations.graphql';

export const useGetUserVideoIntegrations = (): {
    userVideoIntegrations: UserVideoIntegrationsFragment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetUserVideoIntegrationsQuery,
        Record<string, never>
    >(GET_USER_VIDEO_INTEGRATIONS);

    const loggedInUser = data ? data.loggedInUser : null;

    return {
        userVideoIntegrations: loggedInUser,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
